import {useContext} from 'react'
import {VideolabConfigContext} from '../contexts/config'

export function useConfig() {
  const config = useContext(VideolabConfigContext)
  return config
}
